export default __webpack_public_path__ + "static/media/0012.a81d3b54.svg";